import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import _includes from "lodash/includes";
import _find from "lodash/find";
import _some from "lodash/some";
import _every from "lodash/every";
import _size from "lodash/size";
import _get from "lodash/get";
import { createSelector } from 'reselect';
import { FINANCIAL_PORTAL_PRIMARY_SOURCES } from "../constants/account-aggregation";
import { getAllProviderAccounts, getProviderAccountStateIdFromProviderAccount, getSelectedInstitutionId } from "./yodlee";
import { getHasVerifiedPhone } from "./auth";
import * as yodleeUtils from "../utils/yodlee";
export var getSelectedPortalId = function getSelectedPortalId(identity) {
  return _get(identity, 'financialData.selectedPortalId');
};
export var getHasNoYodleeProviderAccounts = function getHasNoYodleeProviderAccounts(identity) {
  var providerAccounts = getAllProviderAccounts(identity);

  if (!_size(providerAccounts)) {
    return true;
  }

  return !_every(getAllProviderAccounts(identity), function (pa) {
    return yodleeUtils.getPrimarySourceFromProviderAccount(pa) === FINANCIAL_PORTAL_PRIMARY_SOURCES.YODLEE;
  });
};
export var getIsInitializingPortal = function getIsInitializingPortal(identity) {
  var institutionId = getSelectedInstitutionId(identity);
  return _some(identity.requests.initializePortal.pendingRequests, function (request) {
    return request.marketplaceInstitutionId === institutionId;
  });
};
export var getIsFetchingPortalDetails = function getIsFetchingPortalDetails(identity) {
  var portalId = getSelectedInstitutionId(identity);
  return _some(identity.requests.getPortalForInstitution.pendingRequests, function (request) {
    return request.marketplaceInstitutionId === portalId;
  });
};
export var getFinancialPortals = function getFinancialPortals(identity) {
  return _get(identity, 'financialData.portalsByInstitutionId');
};
export var getSelectedPortalDetails = createSelector(getSelectedInstitutionId, getFinancialPortals, function (selectedInstitutionId, financialPortals) {
  return _find(financialPortals, function (portal) {
    return portal.marketplaceInstitution.id === selectedInstitutionId;
  });
});
export var getShouldInitializePortal = createSelector(getAllProviderAccounts, getSelectedInstitutionId, getSelectedPortalDetails, getIsInitializingPortal, getHasVerifiedPhone, function (allProviderAccounts, selectedInstitutionId, institutionDetails, hasPendingRequest, hasVerifiedPhone) {
  var linkedInstitutionIds = allProviderAccounts.map(function (pa) {
    return _get(pa, 'provider_account_state.provider.id');
  });

  var isDuplicateLink = _includes(linkedInstitutionIds, selectedInstitutionId);

  if (isDuplicateLink) {
    return false;
  }

  return selectedInstitutionId && !institutionDetails && !hasPendingRequest && hasVerifiedPhone;
});
export var getShouldFetchPortalDetails = createSelector(getAllProviderAccounts, getSelectedInstitutionId, getSelectedPortalDetails, getIsFetchingPortalDetails, getHasVerifiedPhone, function (allProviderAccounts, selectedInstitutionId, institutionDetails, isFetchingPortalDetails, hasVerifiedPhone) {
  var isDuplicateLink = _some(allProviderAccounts, function (pa) {
    return _get(pa, 'provider_account_state.provider.id') === selectedInstitutionId;
  });

  return isDuplicateLink && selectedInstitutionId && !institutionDetails && !isFetchingPortalDetails && hasVerifiedPhone;
});
export var getCurrentlySelectedInstitutionSource = createSelector(getSelectedPortalDetails, function (institutionDetails) {
  return _get(institutionDetails, 'marketplaceInstitution.aggregatorType');
});
export var getMigrationDetails = function getMigrationDetails(identity) {
  return identity.yodlee.onboarding.migrationDetails;
};
export var getSelectedProviderAccountByPortalId = createSelector(getSelectedPortalId, getAllProviderAccounts, function (portalId, providerAccounts) {
  return providerAccounts.find(function (pa) {
    return getProviderAccountStateIdFromProviderAccount(pa) === portalId;
  });
});
export var getMatchedAndMissingAccountsForMigration = createSelector(getSelectedProviderAccountByPortalId, getMigrationDetails, function (providerAccount, migrationDetails) {
  var _ref, _providerAccount$acco;

  var accountsById = (_ref = providerAccount === null || providerAccount === void 0 ? void 0 : (_providerAccount$acco = providerAccount.accounts) === null || _providerAccount$acco === void 0 ? void 0 : _providerAccount$acco.reduce(function (acc, acct) {
    acc[acct.id] = acct;
    return acc;
  }, {})) !== null && _ref !== void 0 ? _ref : {};

  var _ref2 = migrationDetails !== null && migrationDetails !== void 0 ? migrationDetails : {},
      accountsMapping = _ref2.accountsMapping,
      oldAccountIds = _ref2.oldAccountIds;

  var matchedAccounts = [];
  var missingAccounts = [];
  oldAccountIds === null || oldAccountIds === void 0 ? void 0 : oldAccountIds.forEach(function (accountId) {
    if (accountsMapping[accountId]) {
      matchedAccounts.push(accountsById[accountId]);
    } else {
      missingAccounts.push(accountsById[accountId]);
    }
  });
  return {
    matchedAccounts: matchedAccounts,
    missingAccounts: missingAccounts
  };
});
export var isYodleeToPlaidMigrationEnabled = function isYodleeToPlaidMigrationEnabled(identity) {
  return identity.yodlee.onboarding.isYodleeToPlaidMigrationEnabled;
};